import vars from '../helpers';

const $cursor = $('.cursor');

function move(e) {
	if (vars.isMobile()) {
		return;
	}

	gsap.set($cursor, {
		xPercent: -5,
		yPercent: -5,
	});
	gsap.to($cursor, {
		duration: 0.3,
		x: e.clientX,
		y: e.clientY,
	});
}

function show() {
	$cursor.addClass('is-active');
}

function hide() {
	$cursor.removeClass('is-active');
}

function initEvents() {
	if (!vars.isMobile()) {
		vars.$document
			.on('mouseenter.cursor', show)
			.on('mouseleave.cursor', hide)
			.on('mousemove.cursor', move);
	}

	if (vars.isMobile()) {
		let $intro = $('.intro');


		vars.$window.on('scroll', () => {
			let scrollTop = vars.$window.scrollTop();

			if ($intro.offset().top + $intro.height() < scrollTop || $intro.offset().top + $intro.height() === scrollTop) {
				show();
			} else {
				hide();
			}
		})
	}
}

function init() {
	initEvents();
}

init();
